import React, { useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit2, GripVertical } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";

export default function CategoriaCard({ categoria, onEdit, onToggleActive, isDragging }) {
  const [isAdmin, setIsAdmin] = useState(false);

  /* eslint-disable-next-line no-unused-vars */
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      setIsAdmin(true);
    }
  }, [user]);

  return (
    <Card className={`transition-all duration-200 ${
      isDragging ? 'shadow-2xl rotate-2 scale-105' : 'hover:shadow-lg'
    } dark:bg-gray-900 dark:border-gray-800`}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-2">
            <GripVertical className="w-5 h-5 text-gray-400 cursor-move" />
            <h3 className="font-bold text-lg text-gray-900 dark:text-white">{categoria.nombre}</h3>
          </div>
          <Button variant="ghost" size="sm" onClick={() => onEdit(categoria)}>
            <Edit2 className="w-4 h-4" />
          </Button>
        </div>

        <div className="space-y-3">
          {isAdmin && (
            <>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Margen por defecto</span>
                <Badge variant="secondary" className="dark:bg-gray-800">
                  {categoria.margen_defecto}%
                </Badge>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 dark:text-gray-400">Coste fijo</span>
                <Badge variant="secondary" className="dark:bg-gray-800">
                  {categoria.coste_fijo_defecto}€
                </Badge>
              </div>
            </>
          )}

          <div className={`flex justify-between items-center ${isAdmin ? 'pt-3 border-t border-gray-200 dark:border-gray-700' : ''}`}>
            <span className="text-sm text-gray-600 dark:text-gray-400">Activa</span>
            <Switch
              checked={categoria.activa}
              onCheckedChange={(checked) => onToggleActive(categoria.id, checked)}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}